import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["color", "className", "children", "style"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { ButtonBase as MuiButtonBase } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * MUI's IconButton comes with styles that will show a circular background when hovering over an Icon.
 * The border-radius applied was cutting off some of our Icons.
 * https://github.com/mui-org/material-ui/blob/v4.11.0/packages/material-ui/src/IconButton/IconButton.js#L17
 * https://app.asana.com/0/1158562691479736/1198219118247645/f
 *
 * Since the client side designs don't call for a hover for IconButtons,
 * we can wrap an Icon with a ButtonBase, which contains minimum amount of styling
 * https://material-ui.com/api/button-base/
 */
var IconButton = function IconButton(_ref) {
  var color = _ref.color,
    className = _ref.className,
    children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiButtonBase, _objectSpread(_objectSpread({
    disableRipple: true,
    disableTouchRipple: true,
    className: className
    // inline color b/c passing them to makeStyles is really slow
    ,
    style: _objectSpread({
      color: color
    }, style)
  }, props), {}, {
    children: children
  }));
};
export default IconButton;